import type { I18nFn } from 'i18n/types/I18nFn';

export const SearchVolopRefinement = {
  ACTION_DATE: 'actionDate',
  ACTION_TYPE: 'actionType', // @NOTE: actionType is deprecated and will eventually be removed
  AREAS_OF_FOCUS: 'areasOfFocus',
  FUNCTIONS: 'functions',
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  RADIUS: 'radius',
  SOURCE: 'source',
  WELCOME: 'welcome',
  RECENCY: 'recency',
  DONE_IN_A_DAY: 'canBeDoneInADay',
} as const;

export const SEARCH_VOLOP_REFINEMENT_NAMES = Object.values(
  SearchVolopRefinement,
);

export type SearchVolopRefinementType =
  (typeof SearchVolopRefinement)[keyof typeof SearchVolopRefinement];

export function SEARCH_VOLOP_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchVolopRefinement.AREAS_OF_FOCUS]: i18n('Cause Areas'),
    [SearchVolopRefinement.FUNCTIONS]: i18n('Skills'),
    [SearchVolopRefinement.ACTION_DATE]: i18n('Date'),
    [SearchVolopRefinement.LOCALE]: i18n('Listing Language'),
    [SearchVolopRefinement.DONE_IN_A_DAY]: i18n('Show only Done in a Day'),
    [SearchVolopRefinement.LOCATION_TYPE]: i18n('Location Type'),
    [SearchVolopRefinement.SOURCE]: i18n('Source'),
    [SearchVolopRefinement.WELCOME]: i18n('Good For'),
    [SearchVolopRefinement.RADIUS]: i18n('Radius'),
    [SearchVolopRefinement.RECENCY]: i18n('Recency'),
  } as Record<SearchVolopRefinementType, string>;
}
